import { useEffect, useMemo, useRef } from "react";
import { useStyles } from "./RCARegionsDropdown.styles";
import NewMainSelect from "components/NewMainSelect/NewMainSelect.view";
import { useTranslation } from "react-i18next";
import { LocationsEntity } from "entities/Locations/LocationsEntity";
import { IOption } from "components/NewMainSelect/NewMainSelectInterfaces";
import { IRCARegionsDropdown } from "./RCARegionsDropdownInterfaces";

const RCARegionsDropdown = ({
    value,
    onChange,
    handleOnComponentMount,
    multiple,
    className,
    fullWidth,
    placeholder,
    disabled,
    divisionIds,
    loadingDefaults,
}: IRCARegionsDropdown) => {
    const { locationOptions, loading } = LocationsEntity.GetRCAComplianceLocationOptions();
    const classes = useStyles();
    const { t } = useTranslation();

    const options = useMemo(() => {
        const filtered = (locationOptions.region ?? []).filter((region) => {
            if (!divisionIds) return true;
            return region.division && divisionIds.includes(region.division.division_id);
        });
        return filtered.map((region) => ({
            id: region.region_id,
            name: region.name,
        })) as IOption[];
    }, [locationOptions.region, divisionIds]);

    const prevOptionsKeyRef = useRef<string | null>(null);
    useEffect(() => {
        if (!multiple || loading || loadingDefaults) return;
        const optionsKey = options.map((o) => o.id).join(",");
        if (optionsKey === prevOptionsKeyRef.current) return;

        const isFirstFire = prevOptionsKeyRef.current === null;
        if (handleOnComponentMount) handleOnComponentMount(options.map((option) => option.id), isFirstFire);
        prevOptionsKeyRef.current = optionsKey;
    }, [multiple, handleOnComponentMount, options, loadingDefaults, loading]);

    if (multiple) {
        return (
            <NewMainSelect
                fullWidth={false}
                disableMenuPropsStyles
                disabled={disabled}
                multiple
                className={`${classes.select} ${className || ""} ${fullWidth ? classes.fullWidth : ""}`}
                options={options}
                value={value}
                onChange={(selected) => {
                    onChange(selected);
                }}
                placeholder={placeholder || t("data.select_valid_option")}
                withSearchBar
            />
        );
    }

    return (
        <NewMainSelect
            fullWidth={false}
            disableMenuPropsStyles
            disabled={disabled}
            multiple={false}
            withSearchBar
            className={`${classes.select} ${className || ""} ${fullWidth ? classes.fullWidth : ""}`}
            options={options}
            value={value}
            onChange={(selected) => {
                onChange(selected);
            }}
            placeholder={placeholder || t("data.select_valid_option")}
        />
    );
};

export default RCARegionsDropdown;
